module.exports = __webpack_public_path__ + "media/images/add-68c6ab57834b72b597551e5f42507a17.svg";